function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.2188 1.40625C10.3594 1.40625 10.5 1.28906 10.5 1.125V0.375C10.5 0.234375 10.3594 0.09375 10.2188 0.09375H0.28125C0.117188 0.09375 0 0.234375 0 0.375V1.125C0 1.28906 0.117188 1.40625 0.28125 1.40625H10.2188ZM10.2188 5.15625C10.3594 5.15625 10.5 5.03906 10.5 4.875V4.125C10.5 3.98438 10.3594 3.84375 10.2188 3.84375H0.28125C0.117188 3.84375 0 3.98438 0 4.125V4.875C0 5.03906 0.117188 5.15625 0.28125 5.15625H10.2188ZM10.2188 8.90625C10.3594 8.90625 10.5 8.78906 10.5 8.625V7.875C10.5 7.73438 10.3594 7.59375 10.2188 7.59375H0.28125C0.117188 7.59375 0 7.73438 0 7.875V8.625C0 8.78906 0.117188 8.90625 0.28125 8.90625H10.2188Z",
  fill: "#F1C238"
});

var SvgMenuIcon = function SvgMenuIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MenuIcon.f87a8742.svg";
export { ForwardRef as ReactComponent };